import React, { useEffect, useState } from "react";
import { CRMColors } from "../../../models/CRMColors";
import { CRMSpacing } from "../../../models/CRMSpacing";
import { Background } from "../../BuildingBlocks/Background";
import { SpacingRow } from "../../BuildingBlocks/SpacingRow";
import { SpacingColumn } from "../../BuildingBlocks/SpacingColumn";
import { CRMIcon } from "../../CRMIcon/CRMIcon";
import { CRMSingleViewHeader } from "../../Simple/CRMSingleViewHeader/CRMSingleViewHeader";
import { TCaseCustomerSatisfactionForm, TCaseCustomerSatisfactionSentimentActionForm, isCaseCustomerSatisfactionSentimentActionForm, TCaseCustomerSatisfactionNoteTogglePinForm, TCaseCustomerSatisfactionNewNoteForm, TCaseCustomerSatisfactionNewSentimentForm, TCaseCustomerSatisfactionNewRaisedWithOmbudsmanForm, TCaseCustomerSatisfactionNewFormalisedAsComplaintForm, TCaseCustomerSatisfactionDeleteNoteForm, TCaseCustomerSatisfactionNoteActionForm, TCaseCustomerSatisfactionFormAction, TCaseCustomerSatisfactionRaisedWithOmbudsmanActionForm, TCaseCustomerSatisfactionDeleteSentimentForm, TCaseCustomerSatisfactionDeleteRaisedWithOmbudsmanForm, TCaseCustomerSatisfactionDeleteFormalisedAsComplaintForm, TCaseCustomerSatisfactionFormalisedAsComplaintActionForm, TCaseCustomerSatisfactionNewAssignmentForm, TCaseCustomerSatisfactionEmailActionForm, TCaseCustomerSatisfactionNewDeferForm, TCaseCustomerSatisfactionNewComplaintAcknowledgedForm, TCaseCustomerSatisfactionNewComplaintResolvedForm, TCaseCustomerSatisfactionComplaintAcknowledgedActionForm, TCaseCustomerSatisfactionComplaintResolvedActionForm, TCaseCustomerSatisfactionDeleteComplaintAcknowledgedForm, TCaseCustomerSatisfactionDeleteComplaintResolvedForm } from "./../../../../../domain/codecs/form/CaseCustomerSatisfactionForm";
import { TTimelineSentiment } from "../../Simple/CRMTimelineSentiment/CRMTimelineSentiment";
import { CRMBottomControlBar } from "../../CRMBottomControlBar/CRMBottomControlBar";
import { Sticky } from "../../BuildingBlocks/Sticky";
import { WeightBold } from "../../WeightBold/WeightBold";
import { requireExhaustive } from "../../../../../shared/src/util";
import { Relative } from "../../BuildingBlocks/Relative";
import { CRMGrievanceAddNote } from "../CRMGrievanceAddNote/CRMGrievanceAddNote";
import { onChangeFormChildren } from "../../../../../shared/src/codecs/types/form";
import { TCaseCustomerSatisfactionSentiment } from "../../../../../domain/codecs/CaseCustomerSatisfaction";
import { useResolutionStatus } from "../../../hooks/useResolutionStatus";
import { CRMCustomerSatisfactionSingleViewControls } from "../CRMCustomerSatisfactionSingleViewControls/CRMCustomerSatisfactionSingleViewControls";
import { CRMSentimentIcon } from "../../Simple/CRMSentimentIcon/CRMSentimentIcon";
import { CRMStatusVariableConfirmationCountdown } from "../CRMStatusVariableConfirmationCountdown/CRMStatusVariableConfirmationCountdown";
import { CRMStatusVariableSectionPopupPrompt } from "../CRMStatusVariableSectionPopupPrompt/CRMStatusVariableSectionPopupPrompt";
import { CRMCustomerSatisfactionTimeline } from "../CRMCustomerSatisfactionTimeline/CRMCustomerSatisfactionTimeline";
import { CRMBlockPopover } from "../../CRM/CRMBlock/CRMBlockPopover/CRMBlockPopover";
import { CRMPopoutHeader } from "../../Simple/CRMPopoutHeader/CRMPopoutHeader";
import { CRMPlainFilterSearchSelect } from "../CRMPlainFilterSearchSelect/CRMPlainFilterSearchSelect";
import { CRMEmailSingleViewBody } from "../CRMEmailSingleViewBody/CRMEmailSingleViewBody";
import { TDetailedEmailForm, TriageSimpleEmailForm, TTriageSimpleEmailForm } from "../../../../../domain/codecs/form/TriageForm";
import { CRMBlockScrollCacheView } from "../../CRM/CRMBlock/CRMBlockViews/CRMBlockViews";
import { TCaseComplianceRaiseNewForm, TCaseComplianceRaisesForm } from "../../../../../domain/codecs/form/CaseComplianceForm";
import CRMTextAreaComponent from "../../CRMTextAreaComponent/CRMTextAreaComponent";
import { CRMComplaintSlaBanner } from "../CRMComplaintSlaBanner/CRMComplaintSlaBanner";

type TViewStatus =
    "whole-timeline"
    | "pinned-entries-timeline"
;

type TResolutionStatus = 
    "none"
    | "delete-raised-with-ombudsman"
    | "delete-raised-as-a-formal-complaint"
    | "delete-complaint-acknowledged"
    | "delete-complaint-resolved"
    | "delete-note"
    | "delete-sentiment"
;

type TPopupStatus =
    "none"
    | "add-note"
    | "reassign"
    | "mark-sad-sentiment"
    | "mark-happy-sentiment"
    | "raised-with-ombudsman"
    | "raised-as-a-formal-complaint"
    | "complaint-acknowledged"
    | "complaint-resolved"
    | "raised-as-sar"
    | "raised-with-insurers"
    | "delete-a-note"
    | "view-email"
    | "defer"
;

type TCustomerSatisfactionSingleViewProps = {
    form: TCaseCustomerSatisfactionForm;
    onChange: (form: TCaseCustomerSatisfactionForm) => void;
    onSubmitNewNote: (form: TCaseCustomerSatisfactionNewNoteForm) => void;
    onToggleNotePin: (form: TCaseCustomerSatisfactionNoteTogglePinForm) => void;
    onChangeSentiment: (form: TCaseCustomerSatisfactionNewSentimentForm) => void;
    onMarkAsRaisedWithTheOmbudsman: (form: TCaseCustomerSatisfactionNewRaisedWithOmbudsmanForm) => void;
    onMarkRaisedAsAFormalComplaint: (form: TCaseCustomerSatisfactionNewFormalisedAsComplaintForm) => void;
    onMarkComplaintAcknowledged: (form: TCaseCustomerSatisfactionNewComplaintAcknowledgedForm) => void;
    onMarkComplaintResolved: (form: TCaseCustomerSatisfactionNewComplaintResolvedForm) => void;
    onDefer: (form: TCaseCustomerSatisfactionNewDeferForm) => void;
    onReAssign: (form: TCaseCustomerSatisfactionNewAssignmentForm) => void;
    onOpenEmail: (action: TCaseCustomerSatisfactionEmailActionForm) => void;
    
    onDeleteNote: (form: TCaseCustomerSatisfactionDeleteNoteForm) => void;
    onDeleteSentiment: (form: TCaseCustomerSatisfactionDeleteSentimentForm) => void;
    onDeleteRaisedWithOmbudsman: (form: TCaseCustomerSatisfactionDeleteRaisedWithOmbudsmanForm) => void;
    onDeleteRaisedAsAFormalComplaint: (form: TCaseCustomerSatisfactionDeleteFormalisedAsComplaintForm) => void;
    onDeleteComplaintAcknowledged: (form: TCaseCustomerSatisfactionDeleteComplaintAcknowledgedForm) => void;
    onDeleteComplaintResolved: (form: TCaseCustomerSatisfactionDeleteComplaintResolvedForm) => void;

    canManageComplianceReports: boolean;
    complianceForm: TCaseComplianceRaisesForm;
    complianceRaisesCardsSlot: JSX.Element;
    onChangeComplianceForm: (form: TCaseComplianceRaisesForm) => void;
    onMarkRaisedAsSAR: (form: TCaseComplianceRaiseNewForm) => void;
    onMarkRaisedWithInsurers: (form: TCaseComplianceRaiseNewForm) => void;
};

export const CRMCustomerSatisfactionSingleView = (props: React.PropsWithChildren<TCustomerSatisfactionSingleViewProps>): JSX.Element => {

    const [viewStatus, setViewStatus] = useState<TViewStatus>("whole-timeline");
    const [popupViewStatus, setPopupViewStatus] = useState<TPopupStatus>("none");
    const [openedEmail, setOpenedEmail] = useState<TTriageSimpleEmailForm | null>(null);
    const {
        resolutionStatus,
        resolutionData,
        setResolution,
        resetResolution,
    } = useResolutionStatus<TResolutionStatus, TCaseCustomerSatisfactionFormAction>({
        defaultStatus: "none",
    });

    useEffect(
        () => {  
            setOpenedEmail(getOpenedEmail())
        },
        [props.form.children.actions]
    )

    const onChangeChildren = onChangeFormChildren(props.form, props.onChange);

    const isShowingAConfirmationPopup = () => (
        popupViewStatus !== "none" 
        && popupViewStatus !== "add-note"
        && popupViewStatus !== "reassign"
        && popupViewStatus !== "view-email"
    )

    const toggleView = () => setViewStatus(
        viewStatus === "whole-timeline" ?
            "pinned-entries-timeline"
            : "whole-timeline"
    );

    const resetPopupView = () => {
        setPopupViewStatus("none");
        setOpenedEmail(null);
    };

    const getSentiment = (): TTimelineSentiment => {
        const sentimentActions: Array<TCaseCustomerSatisfactionSentimentActionForm> =  props.form.children.actions.filter(
            isCaseCustomerSatisfactionSentimentActionForm
        );
        const lastAction: TCaseCustomerSatisfactionSentimentActionForm | null = sentimentActions.length > 0 ? 
            sentimentActions[sentimentActions.length-1] 
            : null
        ;
        return lastAction?.children.action.sentiment || "happy";
    }

    const onOpenEmail = (form: TCaseCustomerSatisfactionEmailActionForm) => {
        props.onOpenEmail(form);
        setPopupViewStatus("view-email");
        setOpenedEmail(wrapDetailedEmailIntoASimpleOne(form.children.detailed_email_form));
    }

    const getOpenedEmail = (): TTriageSimpleEmailForm | null => {
        
        let openedId = openedEmail?.children.detailed_email_form.original.id;
        let entries = getEntriesToShow();
        let emailEntries = entries
            .filter((entry) => entry.children.tag === "email") as Array<TCaseCustomerSatisfactionEmailActionForm>;
        
        let newOpenedEmail = emailEntries
            .find((entry) => entry.children.detailed_email_form.original.id === openedId);

        if (!!newOpenedEmail && newOpenedEmail.children.detailed_email_form.status === "success") {
            return wrapDetailedEmailIntoASimpleOne(newOpenedEmail.children.detailed_email_form);
        }

        return openedEmail;
    }

    const wrapDetailedEmailIntoASimpleOne = (detailedEmail: TDetailedEmailForm): TTriageSimpleEmailForm => 
        ({
            ...TriageSimpleEmailForm.newDefault(),
            children: {
                detailed_email_form: detailedEmail
            }
        })
    ;

    const getEntriesToShow = (): Array<TCaseCustomerSatisfactionFormAction> => {
        switch (viewStatus) {
            case "whole-timeline":
                return props.form.children.actions;
            case "pinned-entries-timeline":
                return props.form.children.actions.filter((action) => 
                    action.children.tag === "note"
                    && action.children.action.is_pinned
                );
            default:
                return requireExhaustive(viewStatus);
        }
    }

    const getChangedSentimentForm = (sentiment: TCaseCustomerSatisfactionSentiment ): TCaseCustomerSatisfactionNewSentimentForm => ({
        ...props.form.children.create_sentiment_action,
        edited: {
            ...props.form.children.create_sentiment_action.edited,
            sentiment
        }
    }) 

    const onChangeSentimentAsHappy = () =>
        props.onChangeSentiment(
            getChangedSentimentForm("happy")
        )
    ;
    
    const onChangeSentimentAsSad = () =>
        props.onChangeSentiment(
            getChangedSentimentForm("sad")
        )
    ;

    const onRaisedWithOmbudsman = () => {
        props.onMarkAsRaisedWithTheOmbudsman(props.form.children.create_raised_with_ombudsman_action);
    }
    
    const onMarkRaisedAsAFormalComplaint = () => {
        props.onMarkRaisedAsAFormalComplaint(props.form.children.create_formalised_as_complaint_action);
    }

    const onDefer = () => {
        props.onDefer(props.form.children.create_defer_action);
    }

    const onMarkComplaintAcknowledged = () => {
        props.onMarkComplaintAcknowledged(props.form.children.create_complaint_acknowledged_action);
    }

    const onMarkComplaintResolved = () => {
        props.onMarkComplaintResolved(props.form.children.create_complaint_resolved_action);
    }

    const getActionDate = (tag: TCaseCustomerSatisfactionFormAction["children"]["tag"]): string | null =>
        props.form.children.actions.find((action) => action.children.tag === tag)?.children.action.occurred_at ?? null;

    const hasComplaint = (): boolean => getActionDate("formalised_as_complaint") !== null;

    const hasActiveComplianceRaise = (type: "sar" | "raised_with_pi_insurers"): boolean =>
        props.complianceForm.children.raises.some((raise) => raise.children.type === type);

    const onChangeComplianceCreateNote = (key: "create_sar" | "create_insurers", note: string): void => {
        props.onChangeComplianceForm({
            ...props.complianceForm,
            children: {
                ...props.complianceForm.children,
                [key]: {
                    ...props.complianceForm.children[key],
                    edited: { ...props.complianceForm.children[key].edited, note: note === "" ? null : note },
                },
            },
        });
    };

    const onMarkRaisedAsSAR = () => {
        props.onMarkRaisedAsSAR(props.complianceForm.children.create_sar);
    }

    const onMarkRaisedWithInsurers = () => {
        props.onMarkRaisedWithInsurers(props.complianceForm.children.create_insurers);
    }

    const onReAssign = (id: string) => {
        let action = props.form.children.assign_to_users_actions.find((actn) => actn.edited.assigned_to === id);
        if (action) {
            props.onReAssign(action);
            setPopupViewStatus("none");
        }
    };

    // DELETIONS
    const onCompleteDeletingNote = () => {
        props.onDeleteNote((resolutionData as TCaseCustomerSatisfactionNoteActionForm).children.delete_form);
        resetResolution();
    }

    const onCompleteDeletingSentiment = () => {
        props.onDeleteSentiment((resolutionData as TCaseCustomerSatisfactionSentimentActionForm).children.delete_form);
        resetResolution();
    }

    const onCompleteDeletingRaisedWithOmbudsman = () => {
        props.onDeleteRaisedWithOmbudsman((resolutionData as TCaseCustomerSatisfactionRaisedWithOmbudsmanActionForm).children.delete_form);
        resetResolution();
    }

    const onCompleteDeletingComplaintAcknowledged = () => {
        props.onDeleteComplaintAcknowledged((resolutionData as TCaseCustomerSatisfactionComplaintAcknowledgedActionForm).children.delete_form);
        resetResolution();
    }

    const onCompleteDeletingComplaintResolved = () => {
        props.onDeleteComplaintResolved((resolutionData as TCaseCustomerSatisfactionComplaintResolvedActionForm).children.delete_form);
        resetResolution();
    }

    const onCompleteDeletingRaisedAsAFormalComplaint = () => {
        props.onDeleteRaisedAsAFormalComplaint((resolutionData as TCaseCustomerSatisfactionFormalisedAsComplaintActionForm).children.delete_form);
        resetResolution();
    }


    return (
        <CRMBlockScrollCacheView isShowing={true}>
            <Relative>
                {/* POPUP - VIEW EMAIL */}
                {popupViewStatus === "view-email" && !!openedEmail &&
                    <CRMBlockPopover maxHeight="700px">
                        <CRMEmailSingleViewBody
                            headerEdge="border"
                            email={openedEmail}
                            onClose={resetPopupView}
                        />
                    </CRMBlockPopover>
                }

                {/* POPUP - ADD NOTE */}
                {popupViewStatus === "add-note" &&
                    <CRMGrievanceAddNote
                        form={props.form.children.create_note_action}
                        onChange={onChangeChildren("create_note_action")}
                        onSubmit={() => props.onSubmitNewNote(props.form.children.create_note_action)}
                        onClose={resetPopupView}
                    />
                }

                {popupViewStatus === "reassign" &&
                    <CRMBlockPopover maxHeight="700px">
                        <CRMPopoutHeader
                            icon="arrow-left"
                            onClick={() => setPopupViewStatus("none")}
                        >
                            Assign to person
                        </CRMPopoutHeader>

                        <CRMPlainFilterSearchSelect
                            searchStickyTopPosition="51px"
                            options={props.form.children.assign_to_users_actions.map((actionForm) => ({
                                value: actionForm.edited.assigned_to,
                                label: actionForm.edited.assignee_name,
                            }))}
                            placeholder="Search for staff member by name"
                            onClick={onReAssign}
                        />
                    </CRMBlockPopover>
                }

                {isShowingAConfirmationPopup() &&
                    <CRMStatusVariableSectionPopupPrompt
                        status={popupViewStatus}
                        onNo={resetPopupView}
                        variations={{
                            "mark-sad-sentiment": {
                                title: "Change sentiment",
                                formStatus: props.form.children.create_sentiment_action.status,
                                body: <> You are about to change the satisfaction <WeightBold>sentiment</WeightBold> to <WeightBold>unhappy.</WeightBold> Proceed?</>,
                                onYes: onChangeSentimentAsSad
                            },
                            "mark-happy-sentiment": {
                                title: "Change sentiment",
                                formStatus: props.form.children.create_sentiment_action.status,
                                body: <> You are about to change the satisfaction <WeightBold>sentiment</WeightBold> to <WeightBold>happy.</WeightBold> Proceed?</>,
                                onYes: onChangeSentimentAsHappy
                            },
                            "raised-with-ombudsman": {
                                title: "Raise with the ombudsman",
                                formStatus: props.form.children.create_raised_with_ombudsman_action.status,
                                body: <>You are about to note that the client has <WeightBold>raised a complaint with the ombudsman.</WeightBold> Proceed?</>,
                                onYes: onRaisedWithOmbudsman
                            },
                            "raised-as-a-formal-complaint": {
                                title: "Raised as a formal complaint",
                                formStatus: props.form.children.create_formalised_as_complaint_action.status,
                                body: <>You are about to note that the client has <WeightBold>raised a formal complaint.</WeightBold> Proceed?</>,
                                onYes: onMarkRaisedAsAFormalComplaint
                            },
                            "complaint-acknowledged": {
                                title: "Acknowledge complaint",
                                formStatus: props.form.children.create_complaint_acknowledged_action.status,
                                body: <>You are about to record that <WeightBold>this complaint has been formally acknowledged</WeightBold> today. Proceed?</>,
                                onYes: onMarkComplaintAcknowledged,
                                onSuccess: () => setPopupViewStatus("add-note"),
                            },
                            "complaint-resolved": {
                                title: "Resolve complaint",
                                formStatus: props.form.children.create_complaint_resolved_action.status,
                                body: <>You are about to record that the <WeightBold>final written response has been sent</WeightBold> today. Proceed?</>,
                                onYes: onMarkComplaintResolved,
                                onSuccess: () => setPopupViewStatus("add-note"),
                            },
                            "defer": {
                                title: "Defer job",
                                formStatus: props.form.children.create_defer_action.status,
                                body: <>You are about to defer the "Review unhappy satisfaction job" for <WeightBold>7 days.</WeightBold> Proceed?</>,
                                onYes: onDefer
                            },
                            "raised-as-sar": {
                                title: "Mark as raised as SAR",
                                formStatus: props.complianceForm.children.create_sar.status,
                                body: <SpacingColumn spacing={CRMSpacing.SMALL}>
                                    <span>Records that <WeightBold>a Suspicious Activity Report has been filed with the NCA</WeightBold> for this case. <WeightBold>Only compliance staff can see this</WeightBold> — it does not show to other staff, on the timeline, or to the client. Proceed?</span>
                                    <CRMTextAreaComponent
                                        value={props.complianceForm.children.create_sar.edited.note ?? ""}
                                        placeholder="NCA SAR reference — optional, can be added later"
                                        onChange={(value) => onChangeComplianceCreateNote("create_sar", value)}
                                    />
                                </SpacingColumn>,
                                onYes: onMarkRaisedAsSAR
                            },
                            "raised-with-insurers": {
                                title: "Mark as raised with insurers",
                                formStatus: props.complianceForm.children.create_insurers.status,
                                body: <SpacingColumn spacing={CRMSpacing.SMALL}>
                                    <span>Records that this case has been <WeightBold>notified to our professional-indemnity insurers</WeightBold>. <WeightBold>Only compliance staff can see this.</WeightBold> Proceed?</span>
                                    <CRMTextAreaComponent
                                        value={props.complianceForm.children.create_insurers.edited.note ?? ""}
                                        placeholder="Insurer claim / circumstance reference — optional, can be added later"
                                        onChange={(value) => onChangeComplianceCreateNote("create_insurers", value)}
                                    />
                                </SpacingColumn>,
                                onYes: onMarkRaisedWithInsurers
                            },
                        }}
                    />
                }

                {/* HEADER */}
                <Sticky zIndex={4}>
                    <CRMSingleViewHeader
                        title="Timeline"
                    >   
                        <Background padding={`0px ${CRMSpacing.MEDIUM} 0px 0px`}>
                            <SpacingRow spacing={CRMSpacing.SMALL}>
                                <CRMIcon
                                    title={viewStatus === "whole-timeline" ? "See pinned notes" : "See whole timeline"}
                                    iconName={viewStatus === "whole-timeline" ? "pin-list" : "timeline"}
                                    colour="neutral-ink"
                                    onClick={toggleView}
                                />

                                <CRMSentimentIcon sentiment={getSentiment()} />
                            </SpacingRow>
                        </Background>
                    </CRMSingleViewHeader>
                </Sticky>

                {/* BODY */}

                <Background color={CRMColors.NEUTRAL_PAPER}>
                    {/* Restricted compliance cards (SAR + insurers) sit above the
                        timeline; the slot renders nothing for non-flag-holders or
                        when the case has no active raises. */}
                    <CRMComplaintSlaBanner
                        raisedAt={getActionDate("formalised_as_complaint")}
                        acknowledgedAt={getActionDate("complaint_acknowledged")}
                        resolvedAt={getActionDate("complaint_resolved")}
                    />

                    {props.complianceRaisesCardsSlot}

                    <CRMCustomerSatisfactionTimeline
                        entries={getEntriesToShow()}
                        onDeleteRaisedAsAFormalComplaint={setResolution("delete-raised-as-a-formal-complaint")}
                        onDeleteRaisedWithOmbudsman={setResolution("delete-raised-with-ombudsman")}
                        onDeleteComplaintAcknowledged={setResolution("delete-complaint-acknowledged")}
                        onDeleteComplaintResolved={setResolution("delete-complaint-resolved")}
                        onDeleteNote={setResolution("delete-note")}
                        onDeleteSentiment={setResolution("delete-sentiment")}
                        onToggleNotePin={props.onToggleNotePin}
                        onOpenEmail={onOpenEmail}
                    />
                </Background>
                
                {/* CONTROLS */}
                <CRMBottomControlBar>
                    {resolutionStatus !== "none" &&
                        <CRMStatusVariableConfirmationCountdown
                            status={resolutionStatus}
                            onUndo={resetResolution}
                            variations={{
                                "delete-note": ["Deleting Note!", onCompleteDeletingNote],
                                "delete-sentiment": ["Deleting Sentiment!", onCompleteDeletingSentiment],
                                "delete-raised-as-a-formal-complaint": ["Deleting Event!", onCompleteDeletingRaisedAsAFormalComplaint],
                                "delete-raised-with-ombudsman": ["Deleting Event!", onCompleteDeletingRaisedWithOmbudsman],
                                "delete-complaint-acknowledged": ["Deleting Event!", onCompleteDeletingComplaintAcknowledged],
                                "delete-complaint-resolved": ["Deleting Event!", onCompleteDeletingComplaintResolved]
                            }}
                        />
                    }

                    {/* CONTROLS */}
                    {resolutionStatus === "none" &&
                        <CRMCustomerSatisfactionSingleViewControls
                            onAddNote={() => setPopupViewStatus("add-note")}
                            onReAssign={() => setPopupViewStatus("reassign")}
                            onSetSentimentAsHappy={() => setPopupViewStatus("mark-happy-sentiment")}
                            onSetSentimentAsSad={() => setPopupViewStatus("mark-sad-sentiment")}
                            onMarkAsRaisedAsAFormalComplaint={() => setPopupViewStatus("raised-as-a-formal-complaint")}
                            onMarkAsRaisedWithTheOmbudsman={() => setPopupViewStatus("raised-with-ombudsman")}
                            onDefer={() => setPopupViewStatus("defer")}
                            onMarkComplaintAcknowledged={hasComplaint() && getActionDate("complaint_acknowledged") === null ? () => setPopupViewStatus("complaint-acknowledged") : null}
                            onMarkComplaintResolved={hasComplaint() && getActionDate("complaint_resolved") === null ? () => setPopupViewStatus("complaint-resolved") : null}
                            canManageComplianceReports={props.canManageComplianceReports}
                            onMarkAsRaisedAsSAR={hasActiveComplianceRaise("sar") ? null : () => setPopupViewStatus("raised-as-sar")}
                            onMarkAsRaisedWithInsurers={hasActiveComplianceRaise("raised_with_pi_insurers") ? null : () => setPopupViewStatus("raised-with-insurers")}
                        />
                    }
                </CRMBottomControlBar>
            </Relative>
        </CRMBlockScrollCacheView>
    );
};